export default "__VITE_ASSET__5686fb86__"